import { lazy } from 'react';

const NoteDetailsModal = lazy(
  () => import('modules/ElementaryStudentCasefile/modals/NoteDetailsModal'),
);

export default {
  NOTE_DETAILS_MODAL: NoteDetailsModal,
};
